import { ImageComponent } from './image.component';

export const IMAGE_COMPONENTS = [
  ImageComponent
];

export {
  ImageComponent
};



// WEBPACK FOOTER //
// ./src/app/shared/components/images/index.ts